<template>
  <footer class="footer-lp">
    <div class="footer-lp__ue-text">
      <!--<div class="cia-container">
        <p>Projekt „Wzrost konkurencyjności firmy poprzez wprowadzenie nowej
          i&nbsp;innowacyjnej usługi jaką jest uruchomienie
          Centrum Innowacyjnej Archiwizacji w Katowicach.<br/>
          w ramach Regionalnego Programu Operacyjnego Województwa Śląskiego na lata 2014-2020
          Poddziałanie 3.2. Innowacje w MŚP.
        </p>
      </div>-->
    </div>
    <div class="footer-lp__inner cia-container">
      <ul class="footer-lp__nav">
        <li class="footer-lp__item">
          <router-link to="/regulamin">Regulamin</router-link>
        </li>
        <li class="footer-lp__item">
          <router-link to="/polityka-prywatnosci">Polityka prywatności</router-link>
        </li>
      </ul>
      <!--<div class="footer-lp__ue">
        <img src="@/assets/ue.jpg" alt="">
      </div>-->
    </div>
  </footer>
</template>

<script>
export default {
  name: 'cia-footer',
};
</script>

<style lang="scss" scoped>
  .footer-lp {
    border-top: 1px solid #dfdfdf;
    background: #fff;
    position: relative;
    font-size: 14px;
    @media (min-width: 1100px) {
      font-size: 12px;
      height: 125px;
    }
    &__ue-text {
      text-align: center;
      /*padding: 20px 0 0;*/
      font-weight: 300;
      font-size: 12px;
      @media (min-width: 1200px) {
        font-size: 14px;
      }
    }
    &__inner {
      position: relative;
      overflow: hidden;
    }
    &__nav,
    &__item {
      padding: 0;
      margin: 0;
      display: block;
      list-style: none;
      a {
        display: inline-block;
        padding: 5px 0;
      }
    }
    &__item {
      display: inline-block;
      padding: 0 20px;
      @media (min-width: 1100px) {
        padding: 0;
        display: block;
      }
    }
    &__nav {
      text-align: center;
      padding: 20px 0;
      @media (min-width: 1100px) {
        padding-top: 35px;
        text-align: left;
      }
    }
    &__ue {
      padding-bottom: 20px;
      @media (min-width: 1100px) {
        position: absolute;
        padding-bottom: 0;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
      img {
        display: block;
        margin: 0 auto;
        max-width: 100%;
      }
    }
  }
</style>
